import { Desktop } from '@src/application/modules/shared/components/MediaQuery/MediaQuery';
import { useState, useCallback, useEffect } from 'react';
import { useFsVariationsToForceContext, useDefaultVariationId, useCampaignDataMemo } from '../../hooks/fsHooks';
import { FsVariation, FsVariationToForce, FsCampaign } from '../../type';
import FsCampaignSummary from '@src/application/modules/flagship/components/Campaigns/Campaign/CampaignSummary/CampaignSummary';
import { CampaignDetails as FsCampaignDetails } from '@src/application/modules/flagship/components/Campaigns/CampaignDetails/CampaignDetails';
import { addVariationToForceTemp } from '../../fsData/fsActionCreators';
import { CampaignType, ColumnHeaders, FlagshipCampaignColumn } from '@src/application/modules/shared/type';

type FsCampaignProps = {
  test: FsCampaign;
  header: ColumnHeaders<FlagshipCampaignColumn>;
  type: CampaignType;
  handleExpand: () => void;
  expand: boolean;
};

export function FsCampaignWrapper({ test, header, handleExpand, expand, type }: FsCampaignProps) {
  const { dispatchFsVariationToForce, fsVariationToForceState } = useFsVariationsToForceContext();
  const { variationsToForceTemp, variationsToForce } = fsVariationToForceState;

  const CampaignDataMemo = useCampaignDataMemo(test);
  const { variations } = CampaignDataMemo;

  const { defaultVariationId, visitorVariationId } = useDefaultVariationId(test.id);

  const getDefaultVariation = () => {
    return variations.find((x) => x.id === defaultVariationId);
  };
  const [selectedVariation, setSelectedVariation] = useState<FsVariation | undefined>(getDefaultVariation);

  const variationsToForceTempCount = Object.keys(variationsToForceTemp).length;
  const variationsToForceCount = Object.keys(variationsToForce).length;
  const checkVariationToForceCount = variationsToForceTempCount === 0 && variationsToForceCount === 0;
  useEffect(() => {
    if (checkVariationToForceCount) {
      const defaultVariation = getDefaultVariation();
      setSelectedVariation((item) => (item ? defaultVariation : item));
    }
  }, [checkVariationToForceCount]);

  const onVariationChanged = useCallback(
    (arg: FsVariationToForce) => {
      setSelectedVariation(arg.variation);
      dispatchFsVariationToForce(addVariationToForceTemp({ [arg.campaignId]: arg }));
    },
    [visitorVariationId]
  );

  return (
    <>
      <FsCampaignSummary
        test={test}
        CampaignData={CampaignDataMemo}
        defaultVariationId={defaultVariationId}
        expand={handleExpand}
        expanded={expand}
        header={header}
        onVariationChanged={onVariationChanged}
        type={type}
        visitorVariationId={visitorVariationId}
        selectedVariation={selectedVariation}
      />
      <Desktop>
        <FsCampaignDetails expanded={expand} selectedVariation={selectedVariation} campaignId={test.id} />
      </Desktop>
    </>
  );
}
